import types from "./types";

const INITIAL_STATE = {
	recurring_survey: null,
	recurring_surveyError: null,
	recurring_surveyLoading: false,

	//create
	createrecurring_survey: null,
	createrecurring_surveyError: null,
	createrecurring_surveyLoading: false,

	//update
	updaterecurring_survey: null,
	updaterecurring_surveyError: null,
	updaterecurring_surveyLoading: false,

	//delete
	deleterecurring_survey: null,
	deleterecurring_surveyError: null,
	deleterecurring_surveyLoading: false,

	//single item

	singleItem: null,
};

const CustomerSurveyReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case types.GET_RECURRING_SURVEY_START:
			return {
				...state,
				recurring_survey: null,
				recurring_surveyError: null,
				recurring_surveyLoading: true,
			};
		case types.GET_RECURRING_SURVEY_SUCCESS:
			return {
				...state,
				recurring_survey: action.payload,
				recurring_surveyLoading: false,
			};
		case types.GET_RECURRING_SURVEY_ERROR:
			return {
				...state,
				recurring_surveyError: action.payload,
				recurring_surveyLoading: false,
			};
		case types.GET_RECURRING_SURVEY_RESET:
			return {
				...state,
				recurring_surveyError: null,
				recurring_surveyLoading: false,
			};
		//create

		case types.CREATE_RECURRING_SURVEY_START:
			return {
				...state,
				createrecurring_survey: null,
				createrecurring_surveyError: null,
				createrecurring_surveyLoading: true,
			};
		case types.CREATE_RECURRING_SURVEY_SUCCESS:
			return {
				...state,
				createrecurring_survey: action.payload,
				createrecurring_surveyLoading: false,
			};
		case types.CREATE_RECURRING_SURVEY_ERROR:
			return {
				...state,
				createrecurring_surveyError: action.payload,
				createrecurring_surveyLoading: false,
			};
		case types.CREATE_RECURRING_SURVEY_RESET:
			return {
				...state,
				createrecurring_surveyError: null,
				createrecurring_surveyLoading: false,
			};
		//delete

		case types.DELETE_RECURRING_SURVEY_START:
			return {
				...state,
				deleterecurring_survey: null,
				deleterecurring_surveyError: null,
				deleterecurring_surveyLoading: true,
			};
		case types.DELETE_RECURRING_SURVEY_SUCCESS:
			return {
				...state,
				deleterecurring_survey: action.payload,
				deleterecurring_surveyLoading: false,
			};
		case types.DELETE_RECURRING_SURVEY_ERROR:
			return {
				...state,
				deleterecurring_surveyError: action.payload,
				deleterecurring_surveyLoading: false,
			};
		case types.DELETE_RECURRING_SURVEY_RESET:
			return {
				...state,
				deleterecurring_survey: null,
				deleterecurring_surveyError: null,
				deleterecurring_surveyLoading: false,
			};

		//update
		case types.UPDATE_RECURRING_SURVEY_START:
			return {
				...state,
				updaterecurring_survey: null,
				updaterecurring_surveyError: null,
				updaterecurring_surveyLoading: true,
			};
		case types.UPDATE_RECURRING_SURVEY_SUCCESS:
			return {
				...state,
				updaterecurring_survey: action.payload,
				updaterecurring_surveyLoading: false,
			};
		case types.UPDATE_RECURRING_SURVEY_ERROR:
			return {
				...state,
				updaterecurring_surveyError: action.payload,
				updaterecurring_surveyLoading: false,
			};
		case types.UPDATE_RECURRING_SURVEY_RESET:
			return {
				...state,
				updaterecurring_survey: null,
				updaterecurring_surveyError: null,
				updaterecurring_surveyLoading: false,
			};
		//singleItem
		// case types.SINGLE_RECURRING_SURVEY_START:
		// 	return {
		// 		...state,
		// 		updaterecurring_survey: null,
		// 		updaterecurring_surveyError: null,
		// 		updaterecurring_surveyLoading: true,
		// 	};
		// case types.SINGLE_RECURRING_SURVEY_SUCCESS:
		// 	return {
		// 		...state,
		// 		updaterecurring_survey: action.payload,
		// 		updaterecurring_surveyLoading: false,
		// 	};
		// case types.SINGLE_RECURRING_SURVEY_ERROR:
		// 	return {
		// 		...state,
		// 		updaterecurring_surveyError: action.payload,
		// 		updaterecurring_surveyLoading: false,
		// 	};
		// case types.SINGLE_RECURRING_SURVEY_RESET:
		// 	return {
		// 		...state,
		// 		updaterecurring_surveyError: null,
		// 		updaterecurring_surveyLoading: false,
		// 	};

		default:
			return { ...state };
	}
};

export default CustomerSurveyReducer;
